import { useTheme } from "@mui/material";
import { isNumber } from "lodash-es";
import { ReactElement } from "react";

const RadarChartDot: (props: any) => ReactElement<SVGElement> = (props) => {
  const { payload } = props;
  const current = payload.payload.current;
  const previous = payload.payload.previous;

  const theme = useTheme();

  // Calculate the fill color based on score target values - todo drive this with data from the API
  let fill = theme.palette.dsSurface.v300;

  if (isNumber(current) && isNumber(previous)) {
    if (Math.abs(current - previous) < 5) {
      fill = theme.palette.dsPrimary.v300;
    } else if (current < previous) {
      fill = theme.palette.dsDestructive.v300;
    } else if (current > previous) {
      fill = theme.palette.dsPrimary.v300;
    }
  }
  return (
    <circle
      {...props}
      fillOpacity={1}
      fill={fill}
      stroke={"white"}
      strokeWidth={3}
      r={6}
    />
  );
};

export default RadarChartDot;
